import { Dimensions } from "react-native";

export const VW = Dimensions.get("window").width;
export const VH = Dimensions.get("window").height;

export const SPACER_HEIGHT = VH * 0.1;

export const BOX_WIDTH = VW / 10;
export const BOX_HEIGHT = VH * 0.4;
export const GOAL_HEIGHT = VH * 0.8;

export const BALL_SIZE = BOX_WIDTH / 4;
